import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ToolsHelper } from '@app/core/helpers/tools.helper';
import {
  ClusterModel,
  DealModel,
  PlaceModel,
  ProfileModel,
} from '@app/core/models';
import {
  AnalyticsEvents,
  AnalyticsService,
  StorageService,
} from '@app/core/services';
import { APP_CONFIG, IAppConfig } from '@app/core/services/app.config';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
})
export class ActivityComponent implements OnInit {
  @Input() item: DealModel;
  @Input() itemWidth: number;
  @Input() forPopup = false;
  @Input() forBeaconPage = false;
  @Input() beaconId?: number = null;

  profile: ProfileModel;
  placeList: Array<PlaceModel>;
  displayLimit = false;
  displaySuccess = false;
  canPurchase = false;

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: IAppConfig,
    private router: Router,
    private storageService: StorageService,
    private analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.canPurchase =
      this.item.cost >= 0 &&
      this.item.keysNum &&
      this.item.keysNum > this.item.keysUsed;
    this.displayLimit =
      this.item.cost &&
      this.item.keysNum &&
      this.item.keysNum === this.item.keysUsed;

    this.profile = this.storageService.PROFILE;
    this.placeList = this.item.places || [];

    const profileDealList = this.profile ? this.profile.deals || [] : [];
    for (const deal of profileDealList) {
      if (deal.id === this.item.id) {
        this.displaySuccess = true;
        this.canPurchase =
          this.item.cost &&
          this.item.keysNum &&
          this.item.keysNum > this.item.keysUsed &&
          this.item.nCouponsPerPerson > deal.notVerifiedCount;
      }
    }
    if (!this.profile) {
      this.displaySuccess = false;
    }
  }

  openActivityInfo(event: MouseEvent): void {
    event.stopPropagation();

    const parameters: {
      couponId: string;
      clusterId?: number;
      fromPlaceId?: number;
    } = {
      couponId: this.item.id,
    };
    let path: Array<string | number>;

    if (this.appConfig.settings.is_white_label) {
      parameters.clusterId = this.appConfig.settings.cluster;
      path = ['/deals', this.item.slug];
    } else {
      const selectedCluster: ClusterModel =
        this.storageService.SELECTED_CLUSTER;

      parameters.clusterId = selectedCluster.id;
      path = ['/deals', selectedCluster.slug, this.item.slug];
    }

    if (this.beaconId) {
      parameters.fromPlaceId = this.beaconId;
    }

    this.analyticsService.emitEvent(AnalyticsEvents.couponView, parameters);

    this.router.navigate(path);
  }

  getImage(withGradient: boolean = true): any {
    if (withGradient) {
      return {
        'background-image': `linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.49) 100%), ${ToolsHelper.initBackground(
          this.item.image
            .replace('original', 'thumbnail_600x300')
            .replace('.png', '.jpg'),
        )}`,
      };
    }
    return {
      'background-image': ToolsHelper.initBackground(
        this.item.image
          .replace('original', 'thumbnail_600x300')
          .replace('.png', '.jpg'),
      ),
    };
  }

  getEmojiImage(): any {
    return {
      'background-image': ToolsHelper.initBackground(
        this.placeList[0].emojiUrl,
      ),
    };
  }
}
